export const getTunnelTestConnectionResult = 'getTunnelTestConnectionResult';
export const isTunnelTestConnectionResultSuccessful =
  'isTunnelTestConnectionResultSuccessful';
